import { ExtendedProductPageSelectorOption } from './exploreOptions';

const markSelectedOption = (options: ExtendedProductPageSelectorOption[], value: string, productId: number) => {
  const targetOption = options.find((option) => option.value === value);
  if (targetOption) {
    targetOption.selected = true;
    targetOption.productId = productId;
  }
  return options;
};

export default markSelectedOption;
